import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import useFeatureFlag from 'App/hooks/useFeatureFlag';
import { PERMISSION_TYPES } from 'App/utils/isPermitted/isPermitted';
import { PdxPatientType } from './types/PatientType';

const PdxPatientViewModal = ({ patient, onClose }) => {
    const isServerlessRouteEnabled = useFeatureFlag(PERMISSION_TYPES.ENABLE_PDX_SLS);
    const medications = [...(patient?.OtherMedication || [])]
        .filter(Boolean)
        .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
    const medicationRows = [];

    for (let i = 0; i < medications.length; i += 30) {
        medicationRows.push(medications.slice(i, i + 30));
    }

    return (
        <Modal show size="lg">
            <Modal.Header>
                <Modal.Title role="heading">Rx.com Patient Profile</Modal.Title>
            </Modal.Header>

            <Modal.Body id="pdx-patient-view-body">
                <div className="table-responsive">
                    <h4>Patient Demographics</h4>
                    <table className="therigy-table">
                        <colgroup>
                            <col width="15%" />
                            <col width="25%" />
                            <col width="35%" />
                            <col width="15%" />
                            <col width="10%" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>Rx.com ID</th>
                                <th>Name</th>
                                <th>Address</th>
                                <th>DOB</th>
                                <th>Sex</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="therapy-row">
                                <td>{patient?.ExternalId}</td>
                                <td>
                                    {patient?.FirstName}&nbsp;{patient?.MiddleName}
                                    &nbsp;{patient?.LastName}
                                </td>
                                <td>
                                    {patient?.AddressLine1} {patient?.AddressLine2}
                                    {(patient?.AddressLine1 || patient?.AddressLine2) && <br />}
                                    {patient.City}, {patient.State} {patient.Zip}
                                </td>
                                <td>{patient?.BirthDate}</td>
                                <td>{patient?.Gender}</td>
                            </tr>
                        </tbody>
                    </table>

                    <h4>Patient Contact</h4>
                    <table className="therigy-table">
                        <thead>
                            <tr>
                                <th>Email</th>
                                <th>Home Phone</th>
                                <th>Mobile Phone</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="therapy-row">
                                <td>{patient?.Email || '--'}</td>
                                <td>{patient?.HomePhone || '--'}</td>
                                <td>{patient?.MobilePhone || '--'}</td>
                            </tr>
                        </tbody>
                    </table>

                    <h4>Patient Medication</h4>
                    <table className="therigy-table">
                        <colgroup>
                            <col width="33%" />
                            <col width="33%" />
                            <col width="33%" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>{isServerlessRouteEnabled ? 'Medication(s):' : 'Medication:'}</th>
                                <th>&#8203;</th>
                                <th>&#8203;</th>
                            </tr>
                        </thead>
                        <tbody>
                            {medicationRows.length > 0 ? (
                                medicationRows.map((row) => (
                                    <tr className="therapy-row">
                                        {[0, 1, 2].map((columnIndex) => {
                                            const columnMedications = row.slice(
                                                columnIndex * 10,
                                                (columnIndex + 1) * 10
                                            );

                                            return (
                                                <td>
                                                    {columnMedications.length > 0 ? (
                                                        <ul style={{ margin: 0 }}>
                                                            {columnMedications.map((medication) => (
                                                                <li>{medication}</li>
                                                            ))}
                                                        </ul>
                                                    ) : null}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                ))
                            ) : (
                                <tr className="therapy-row">
                                    <td>--</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <div style={{ flexGrow: 1 }} />

                <Button variant="outline-secondary" onClick={onClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

PdxPatientViewModal.propTypes = {
    patient: PdxPatientType.isRequired,
    onClose: PropTypes.func.isRequired,
};

PdxPatientViewModal.defaultProps = {};

export default PdxPatientViewModal;
